import { post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'

export const changeReassignment = (name, value) => ({
    type: type.CHANGE_REASSIGNMENT,
    payload: {
        name,
        value,
    },
})

const reassignTreatingPhysicianRequest = () => ({
    type: type.REASSIGN_TREATING_PHYSICIAN_REQUEST,
})

const reassignTreatingPhysicianSuccess = () => ({
    type: type.REASSIGN_TREATING_PHYSICIAN_SUCCESS,
})

const reassignTreatingPhysicianError = (error) => ({
    type: type.REASSIGN_TREATING_PHYSICIAN_ERROR,
    payload: {
        error,
    },
})

export const reassignTreatingPhysician = () => (dispatch, getState) => {
    const state = getState()

    const confirmation = selector.selectConfirmationLegalRequirementsMet(state)
    const currentTreatingPhysicianId = selector.selectCurrentTreatingPhysicianId(state)
    const newTreatingPhysicianId = selector.selectNewTreatingPhysicianId(state)
    if (!confirmation || !currentTreatingPhysicianId || !newTreatingPhysicianId) {
        return
    }

    dispatch(reassignTreatingPhysicianRequest())

    post('/api/customer/reassign-treating-physician', {
        currentTreatingPhysicianId,
        newTreatingPhysicianId,
    })
        .then(() => {
            dispatch(reassignTreatingPhysicianSuccess())
        })
        .catch(error => {
            dispatch(reassignTreatingPhysicianError(error))
        })
}


const reassignToPartnerPhysicianRequest = () => ({
    type: type.REASSIGN_TO_PARTNER_PHYSICIAN_REQUEST,
})

const reassignToPartnerPhysicianSuccess = () => ({
    type: type.REASSIGN_TO_PARTNER_PHYSICIAN_SUCCESS,
})

const reassignToPartnerPhysicianError = (error) => ({
    type: type.REASSIGN_TO_PARTNER_PHYSICIAN_ERROR,
    payload: {
        error,
    },
})

export const reassignToPartnerPhysician = () => (dispatch, getState) => {
    const state = getState()

    const confirmation = selector.selectConfirmationLegalRequirementsMet(state)
    const currentTreatingPhysicianId = selector.selectCurrentTreatingPhysicianId(state)
    const partnerPhysicianId = selector.selectPartnerPhysicianId(state)
    if (!confirmation || !currentTreatingPhysicianId || !partnerPhysicianId) {
        return
    }

    dispatch(reassignToPartnerPhysicianRequest())

    post('/api/customer/reassign-to-partner-physician', {
        currentTreatingPhysicianId,
        partnerPhysicianId,
    })
        .then(() => {
            dispatch(reassignToPartnerPhysicianSuccess())
        })
        .catch(error => {
            dispatch(reassignToPartnerPhysicianError(error))
        })
}





// WEBPACK FOOTER //
// ./src/modules/treatment/state/reassign/action.js